import type { ReceiptTemplate } from '../schema';

export const receiptHogTemplate: ReceiptTemplate = {
  id: 'receipt-hog',
  name: 'Receipt Hog Receipt',
  brand: 'RECEIPT HOG',
  description: 'Receipt Hog coins receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: 'none',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'rh-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'RECEIPT HOG',
        businessNameFontSize: 18,
        addressLines: ['COINS EARNED'],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'rh-scan',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'scan', label: 'Receipt #:', value: 'RH-847291034' },
          { id: 'user', label: 'Hogger:', value: 'JohnDoe123' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'store', label: 'Store:', value: 'TARGET' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'rh-coins',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'spin', label: 'HOG SLOTS', value: '1 spin', isBold: false, isLarge: false },
          { id: 'coins', label: 'COINS EARNED', value: '20', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'rh-balance',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: 'COIN BALANCE: 1,450\n\nOINK OINK!', fontSize: 12, showDivider: false, dividerStyle: 'solid', isBold: false },
    },
  ],
  updatedAt: new Date().toISOString(),
};

